var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../lib/utils.js";
const _buttonVariants = cva(
  cn`
    inline-flex shrink-0 items-center justify-center border border-solid bg-clip-border
    whitespace-nowrap text-sm font-medium transition-all outline-none
    focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]
    disabled:pointer-events-none disabled:text-(--gray-border-3) disabled:cursor-not-allowed
    aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive
    [&_svg]:pointer-events-none [&_svg:not([class*=\'size-\'])]:size-4 [&_svg]:shrink-0
  `,
  {
    variants: {
      /** @deprecated */
      variant: {
        default: "",
        destructive: "",
        "destructive-secondary": "",
        outline: "",
        secondary: "",
        "secondary-theme": "",
        ghost: "",
        link: ""
      },
      size: {
        default: "gap-2 has-[>svg]:px-3",
        sm: "gap-1.5 has-[>svg]:px-2.5",
        lg: "gap-2 has-[>svg]:px-4",
        /** @deprecated */
        icon: "size-9"
        // 保留用于兼容
      },
      shape: {
        default: "rounded-md",
        circle: "rounded-full",
        square: "rounded-md"
      },
      /**
       * 设置button的变体，包括：
       * default   背景是主色，文字是白色，无border
       * outlined  背景是主色系，文字是主色，有border
       * ghost     hover时才有背景，文字是主色，无border
       * link      无背景，hover时有颜色和下划线，无border
       * filled    主色和危险颜色时，显示次级颜色
       */
      buttonVariant: {
        default: "border-transparent disabled:bg-(--gray-tag-1-alpha)",
        outlined: "disabled:border-(--gray-border-1-alpha) disabled:bg-(--gray-bg-2)",
        ghost: "border-transparent",
        link: "border-transparent underline-offset-4 hover:underline",
        filled: "border-transparent disabled:bg-(--gray-tag-1-alpha)"
      },
      /**
       * 设置button的颜色
       * primary   主色
       * secondary 次级颜色（灰色）
       * danger    危险颜色
       */
      color: {
        primary: "",
        secondary: "",
        danger: ""
      }
    },
    compoundVariants: [
      {
        color: "primary",
        buttonVariant: "default",
        class: "bg-(--primary-1) hover:bg-(--primary-2) focus-visible:bg-(--primary-2) active:bg-(--primary-2) text-(--pure-white)"
      },
      {
        color: "primary",
        buttonVariant: "outlined",
        class: "border-(--border-2-alpha) bg-(--bg-2-alpha) focus-visible:bg-(--tag-1-alpha) active:bg-(--tag-1-alpha) text-(--text-1-alpha)"
      },
      {
        color: "primary",
        buttonVariant: "ghost",
        class: "hover:bg-(--tag-1-alpha) focus-visible:bg-(--tag-2-alpha) active:bg-(--tag-2-alpha) text-(--text-1-alpha)"
      },
      {
        color: "primary",
        buttonVariant: "link",
        class: "text-(--text-1-alpha)"
      },
      {
        color: "primary",
        buttonVariant: "filled",
        class: "bg-(--tag-1-alpha) hover:bg-(--tag-2-alpha) focus-visible:bg-(--tag-3-alpha) active:bg-(--tag-3-alpha) text-(--text-1-alpha)"
      },
      {
        color: "secondary",
        buttonVariant: ["default", "filled"],
        class: "bg-(--gray-tag-1) hover:bg-(--gray-tag-2) focus-visible:bg-(--gray-tag-3) active:bg-(--gray-tag-3) text-(--gray-text-1)"
      },
      {
        color: "secondary",
        buttonVariant: "outlined",
        class: "border-(--gray-border-3) hover:bg-(--gray-bg-2-alpha) focus-visible:bg-(--gray-tag-1-alpha) active:bg-(--gray-tag-1-alpha) text-(--gray-text-1)"
      },
      {
        color: "secondary",
        buttonVariant: "ghost",
        class: "hover:bg-(--gray-tag-1-alpha) focus-visible:bg-(--gray-tag-2-alpha) active:bg-(--gray-tag-2-alpha) text-(--gray-text-1-alpha)"
      },
      {
        color: "secondary",
        buttonVariant: "link",
        class: "text-(--gray-text-1-alpha)"
      },
      {
        color: "danger",
        buttonVariant: "default",
        class: "bg-(--red-9) hover:bg-(--red-10) focus-visible:bg-(--red-10) active:bg-(--red-10) text-(--pure-white)"
      },
      {
        color: "danger",
        buttonVariant: "outlined",
        class: "border-(--red-8-alpha) focus-visible:bg-(--red-2-alpha) active:bg-(--red-3-alpha) text-(--red-11)"
      },
      {
        color: "danger",
        buttonVariant: "ghost",
        class: "hover:bg-(--red-3-alpha) focus-visible:bg-(--red-4-alpha) active:bg-(--red-4-alpha) text-(--red-11)"
      },
      {
        color: "danger",
        buttonVariant: "link",
        class: "text-(--red-11)"
      },
      {
        color: "danger",
        buttonVariant: "filled",
        class: "bg-(--red-3-alpha) hover:bg-(--red-4-alpha) focus-visible:bg-(--red-5-alpha) active:bg-(--red-5-alpha) text-(--red-11)"
      },
      {
        size: "default",
        shape: "default",
        class: "h-9 px-4 py-2"
      },
      {
        size: "sm",
        shape: "default",
        class: "h-8 px-3"
      },
      {
        size: "lg",
        shape: "default",
        class: "h-10 px-6"
      },
      {
        size: "default",
        shape: ["circle", "square"],
        class: "size-9"
      },
      {
        size: "sm",
        shape: ["circle", "square"],
        class: "size-8"
      },
      {
        size: "lg",
        shape: ["circle", "square"],
        class: "size-10"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      shape: "default",
      color: "primary",
      buttonVariant: "default"
    }
  }
);
function oldVariants(props) {
  let color, buttonVariant;
  switch (props.variant) {
    case "secondary":
      color = "secondary";
      break;
    case "outline":
      [color, buttonVariant] = ["secondary", "outlined"];
      break;
    case "ghost":
      [color, buttonVariant] = ["secondary", "ghost"];
      break;
    case "link":
      buttonVariant = "link";
      break;
    case "destructive":
      color = "danger";
      break;
    case "destructive-secondary":
      [color, buttonVariant] = ["danger", "filled"];
      break;
    case "secondary-theme":
      buttonVariant = "filled";
      break;
  }
  return { color, buttonVariant };
}
__name(oldVariants, "oldVariants");
function buttonVariants(props) {
  return props ? props != null && props.variant ? _buttonVariants({ ...props, ...oldVariants(props) }) : _buttonVariants(props) : _buttonVariants();
}
__name(buttonVariants, "buttonVariants");
export {
  _buttonVariants,
  buttonVariants
};
//# sourceMappingURL=variants.js.map
